import React from "react";
import "../../Css/Hero.css";

const Hero = () => {
  return (
    <section className="hero">
      {/* LEFT CONTENT */}
      <div className="hero-left">
        <div className="welcome-badge">
          <span className="dot"></span>
          WELCOME TO ELITENOVA
        </div>

        <h1 className="hero-title">
          Building Digital <br />
          Solutions for <br />
          <span>Modern Businesses</span>
        </h1>

        <p className="hero-description">
          EliteNova is a modern software development company that helps
          businesses grow digitally by building premium websites,
          applications, and intelligent software solutions.
        </p>

        <div className="hero-buttons">
          {/* <button className="primary-btn">🚀 Get Started</button> */}
          {/* <button className="secondary-btn">▶ View Projects</button> */}

              <a
            href="https://ecommobileappreactnative.firebaseapp.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="secondary-btn"
          >
            ▶ View Ecommerce Business
          </a>
        </div>
      </div>

      {/* RIGHT CONTENT */}
      <div className="hero-right">
        <div className="screen main-screen">
          <div className="screen-navbar">
            <h3>ELITENOVA</h3>

            <ul>
              <li>Home</li>
              <li>About</li>
              <li>Services</li>
              <li>Projects</li>
            </ul>

            <button>Get Started</button>
          </div>

          <div className="screen-content">
            <div className="screen-text">
              <h2>
                We Build <span>Digital Experiences</span> <br />
                That Drive Results
              </h2>

              <p>
                Modern websites, powerful applications, and intelligent
                software solutions for your business.
              </p>

              <button>Explore Services</button>
            </div>

            <div className="cube-container">
              <div className="cube cube1"></div>
              <div className="cube cube2"></div>
              <div className="cube cube3"></div>
              <div className="cube cube4"></div>
            </div>
          </div>
        </div>

        {/* Floating Mobile */}
        <div className="mobile-card">
          <h4>Smart Solutions</h4>
          <p>We create digital products that help you grow faster.</p>
        </div>

        {/* Floating Laptop */}
        <div className="laptop-card">
          <h4>Intelligent Software</h4>
          <p>Custom solutions built for scale & performance.</p>
        </div>
      </div>
    </section>
  );
};

export default Hero;